import { yupResolver } from "@hookform/resolvers/yup";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { JVDropdown } from "../../../shared/JVDropdown";
import { JVInput } from "../../../shared/JVInput";
import { JVDate } from "../../../shared/JVDate";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Fetch } from "../../../shared/Fetch";
import { IWorkStream } from "./WorkStreamList";
interface Iprops {
  singleData: any;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}
const schema = yup.object({
  workstream_Category_ID: yup.number().moreThan(0, "Work Stream Category is required").required(),
  title: yup.string().trim().required("Title is required"),
  assigned_To: yup.number().moreThan(0, "Assigned User is required").required(),
});
const Form = (props: Iprops) => {
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [users, setUsers] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    watch,
  } = useForm<IWorkStream>({
    resolver: yupResolver(schema),
    defaultValues: {
      id: 0,
      tender_ID: 0,
      workstream_Category_ID: 0,
      title: "",
      description: "",
    },
    shouldFocusError: false,
  });
  const onHide = () => {
    props.hideDialog();
    reset();
  };
  const save = async (data: IWorkStream) => {
    try {
      setLoading(true);
      const body = {
        id: data.id,
        tender_ID: data.tender_ID,
        workstream_Category_ID: data.workstream_Category_ID,
        title: data.title,
        description: description,
        assigned_To: data.assigned_To,
        deadline_Date: data.deadline_Date,
      };

      const response = await Fetch(`Tender_Mast/UpdateTenderWorkStream/${data.id}`, "PUT", body, null, props.toast);

      if (response?.ok) {
        props.toast.current?.show({ severity: "success", summary: "Success", detail: "Work Stream Updated Successfully", life: 3000 });
        props.setReload(!props.reload);
        closeEdit();
      }
    } finally {
      setLoading(false);
    }
  };
  const closeEdit = () => {
    reset();
    setDescription("");
    props.hideDialog();
  };
  const loadUsers = async (categoryId: number) => {
    const response = await Fetch("TenderWorkstream/GetUsersByWorkstreamCategory", "GET", null, `workstreamCategoryId=${categoryId}`, props.toast);

    if (response?.ok) {
      const data = await response.json();
      setUsers(data);
    }
  };
  const loadCategories = async () => {
    const response = await Fetch("Tender_Mast/TenderWorkStreamCategoryDropdown", "GET", null, null, props.toast);
    if (response?.ok) {
      const data = await response.json();
      setCategories(data);
    }
  };

  const selectedCategory = watch("workstream_Category_ID");

  useEffect(() => {
    if (selectedCategory > 0) {
      loadUsers(selectedCategory);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory]);

  useEffect(() => {
    loadCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.open && props.singleData) {
      reset({
        id: props.singleData.id,
        tender_ID: props.singleData.tender_ID,
        workstream_Category_ID: props.singleData.workstream_Category_ID,
        title: props.singleData.title,
        description: props.singleData.description,
        assigned_To: props.singleData.assigned_To_ID,
        deadline_Date: props.singleData.deadline_Date ? new Date(props.singleData.deadline_Date) : null,
      });

      setDescription(props.singleData.description ?? "");

      if (props.singleData.workstream_Category_ID > 0) {
        loadUsers(props.singleData.workstream_Category_ID);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open, props.singleData]);
  return (
    <>
      <Dialog visible={props.open} modal style={{ width: "55vw" }} header="Edit Work Stream" onHide={onHide}>
        <form onSubmit={handleSubmit(save)} className="p-fluid formgrid grid">
          <JVDropdown required column={3} label="Work Stream Category" control={control} name="workstream_Category_ID" options={categories} optionLabel="category_Name" optionValue="id" placeholder="Select Category" error={errors.workstream_Category_ID?.message}/>
          <JVInput required column={3} label="Title" control={control} name="title" error={errors.title?.message} />
          <JVDropdown filter required column={3} label="Assigned User" control={control} name="assigned_To" options={users} optionLabel="user_Name" optionValue="login_ID" placeholder="Select User" />
          <JVDate required column={4} label="Deadline Date" control={control} name="deadline_Date" minDate={new Date()} error={errors.deadline_Date?.message} />
          <div className="field col-12">
            <label>Description</label>
            <InputTextarea value={description} rows={4} className="w-full" onChange={(e) => setDescription(e.target.value)} />
          </div>
          <div className="col-12 flex justify-content-end gap-2">
            <Button label="Update" loading={loading} type="submit" />
            <Button style={{ width: "100px" }} label="CLOSE" type="button" onClick={onHide} className="p-button-outlined" />
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default Form;
